import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'reimbursementExcelExport';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const reimbursementExcelExportActions = { ...slice.actions, ...extraActions };
export const reimbursementExcelExportReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        reimbursementExcelExport: {},
        //dashboardArgs: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/Reimbursement`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async (postData)  => await fetchWrapper.post(`${baseUrl}/ExportToExcel`, {postData})
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.reimbursementExcelExport = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.reimbursementExcelExport = action.payload;
                // state.dashboardArgs = action.meta.arg;                
            },
            [rejected]: (state, action) => {
                state.reimbursementExcelExport = { error: action.error };
            }
        };
    }
}
